// import React, { useState, useEffect } from 'react'; // Added useEffect
// import { motion, AnimatePresence } from 'framer-motion';
// // Import Toast components
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { 
//   Phone, Mail, MapPin, Send, MessageSquare, 
//   Clock, CheckCircle2, Linkedin, Twitter, 
//   Facebook, Instagram, Loader2, ChevronDown,
//   RefreshCcw // Added for captcha refresh
// } from 'lucide-react';

// import Image1 from "../../assets/ivr.webp";
// import Image2 from "../../assets/ivr2.webp";

// // 1. Import FontAwesome components and icons
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faPhoneVolume,
//   faUserGear,
//   faMicrophone,
//   faPlayCircle,
//   faListUl,
//   faCloudArrowDown,
//   faPhone,
//   faKeyboard,
//   faHeadset,
//   faPhoneSlash,
//   faPaperPlane, 
// } from "@fortawesome/free-solid-svg-icons";

// import HostedImg from "../../assets/ivr3.png"
// import OnPremiseImg from "../../assets/ivr4.png"
// import AutomatedImg from "../../assets/ivr5.png"
// import { API_URL } from '../../../Constants';

// // --- Contact Section Helpers ---
// const containerVariants = {
//   hidden: { opacity: 0 },
//   visible: { opacity: 1, transition: { staggerChildren: 0.1, delayChildren: 0.1 } }
// };

// const itemVariants = {
//   hidden: { opacity: 0, y: 15 },
//   visible: { opacity: 1, y: 0, transition: { type: "spring", stiffness: 100, damping: 20 } }
// };

// const InputField = ({ label, type = "text", placeholder, name, value, onChange, required, readOnly, className }) => (
//   <div className="flex flex-col space-y-1.5">
//     <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
//     <input
//       type={type}
//       name={name}
//       value={value}
//       onChange={onChange}
//       placeholder={placeholder}
//       required={required}
//       readOnly={readOnly}
//       className={`w-full px-5 py-3.5 text-sm md:text-base rounded-xl border transition-all duration-300 focus:outline-none ${
//         readOnly 
//         ? "bg-gray-100 border-gray-200 text-gray-500 cursor-not-allowed" 
//         : "bg-gray-50 border-gray-200 text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550]"
//       } ${className}`}
//     />
//   </div>
// );

// const TextArea = ({ label, placeholder, name, value, onChange, required }) => (
//   <div className="flex flex-col space-y-1.5">
//     <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
//     <textarea
//       name={name}
//       value={value}
//       onChange={onChange}
//       rows="4"
//       placeholder={placeholder}
//       required={required}
//       className="w-full px-5 py-3.5 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all duration-300 resize-none"
//     />
//   </div>
// );

// const ContactDetail = ({ icon: Icon, title, content, subContent }) => (
//   <motion.div variants={itemVariants} className="flex items-start gap-3 p-2 rounded-xl hover:bg-white/10 transition-colors duration-300 group cursor-default">
//     <div className="p-2 bg-white/10 rounded-lg group-hover:bg-[#F46653] transition-colors duration-300 shadow-sm">
//       <Icon className="text-white w-4 h-4" />
//     </div>
//     <div>
//       <h4 className="text-white/60 text-[10px] font-medium uppercase tracking-wider mb-0">{title}</h4>
//       <p className="text-white text-base font-bold leading-tight">{content}</p>
//       {subContent && <p className="text-white/70 text-xs mt-0">{subContent}</p>}
//     </div>
//   </motion.div>
// );

// export const Ivr = () => {
//   const features = [
//     { id: 1, icon: faPhoneVolume, title: "Call Routing", description: `Routing calls to the appropriate department or individual based on the caller's selection. A customer calls a company and an IVR system greets them. The system might say, "Press 1 for sales, 2 for support, 3 for billing." Based on the caller's selection, the call is routed appropriately.`, gradient: "bg-gradient-to-br from-blue-100 to-indigo-50" },
//     { id: 2, icon: faUserGear, title: "Self-Service Options", description: `Our IVR solution allows you to access self-services such as checking account balances, paying bills, or updating personal information without the need for speaking with a live representative.`, gradient: "bg-gradient-to-br from-emerald-50 to-teal-50" },
//     { id: 3, icon: faMicrophone, title: "Speech Recognition", description: `With speech recognition technology, our IVR solution enabling callers to speak their responses instead of using a keypad. This creates a more seamless and natural interaction, reducing frustration and improving overall experience.`, gradient: "bg-gradient-to-br from-purple-50 to-fuchsia-50" },
//     { id: 4, icon: faPlayCircle, title: "Pre-recorded Messages", description: `Pre-recorded voice messages guide the caller through the available options. These can be customized to suit the specific needs of a business and can include multi-lingual prompts for diverse customer bases.`, gradient: "bg-gradient-to-br from-amber-50 to-orange-50" },
//     { id: 5, icon: faListUl, title: "Multi-level Menus", description: `Our IVR solution provides you multi-level menus where users can drill down through several options to access more specific services. For instance, after selecting “customer service”, callers may be asked to select a specific issue.`, gradient: "bg-gradient-to-br from-rose-50 to-pink-50" },
//     { id: 6, icon: faCloudArrowDown, title: "Real-Time Data Integration", description: `Our IVR solution can integrate with backend databases or CRM (Customer Relationship Management) systems to provide real-time information. For example, accessing a customer’s account details in real-time to provide balance information.`, gradient: "bg-gradient-to-br from-cyan-50 to-sky-50" },
//   ];

//   const workingSteps = [
//     { id: 1, icon: faPhone, title: "Call Initiation", description: "A customer calls a business and is greeted by the IVR system, which plays a recorded greeting and presents options through voice prompts.", gradient: "bg-gradient-to-br from-blue-100 to-indigo-50" },
//     { id: 2, icon: faKeyboard, title: "Input from Customer", description: "The caller interacts with the system by pressing keys on their phone (Dual-Tone Multi-Frequency or DTMF) or speaking their choices if speech recognition is enabled.", gradient: "bg-gradient-to-br from-emerald-50 to-teal-50" },
//     { id: 3, icon: faMicrophone, title: "Processing Input", description: "The IVR system processes the input (whether keypad selection or voice command) and determines the appropriate action, such as routing the call or providing information.", gradient: "bg-gradient-to-br from-purple-50 to-fuchsia-50" },
//     { id: 4, icon: faHeadset, title: "Completion or Further Interaction", description: "The system either completes the transaction or continues interacting to gather details. If necessary, the call is transferred to a live representative.", gradient: "bg-gradient-to-br from-amber-50 to-orange-50" },
//     { id: 5, icon: faPhoneSlash, title: "End of Call", description: "Once the query is resolved or the transaction is completed, the call is disconnected automatically or by the user.", gradient: "bg-gradient-to-br from-rose-50 to-pink-50" },
//   ];

//   const ivrTypes = [
//     { id: "01", image: HostedImg, title: "Hosted IVR (Cloud-based IVR)", description: "A cloud-based or hosted IVR system is managed off-site by a third-party provider. This eliminates the need for businesses to invest in on-premise infrastructure and allows for easier scalability. Hosted IVR is popular among businesses that need flexible, cost-effective solutions." },
//     { id: "02", image: OnPremiseImg, title: "On-premise IVR", description: "On-premise IVR solutions are installed within a company's infrastructure. These solutions provide more control and customization options but come with higher upfront costs and maintenance requirements." },
//     { id: "03", image: AutomatedImg, title: "Automated IVR", description: "An automated IVR system operates without human intervention, automating the entire call process. It includes routine customer service interactions like checking balances or processing payments." },
//   ];

//   // Updated formState keys to match API
//   const [formState, setFormState] = useState({ fullName: '', email: '', phoneNumber: '', subject: 'IVR Inquiry', message: '' });
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   // --- CAPTCHA LOGIC ---
//   const [captchaText, setCaptchaText] = useState('');
//   const [userInputCaptcha, setUserInputCaptcha] = useState('');

//   const generateCaptcha = () => {
//     const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789"; 
//     let result = "";
//     for (let i = 0; i < 6; i++) {
//       result += chars.charAt(Math.floor(Math.random() * chars.length));
//     }
//     setCaptchaText(result);
//     setUserInputCaptcha('');
//   };

//   useEffect(() => {
//     generateCaptcha();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
    
//     if (name === 'phoneNumber') {
//         const cleaned = value.replace(/\D/g, ''); 
//         if (cleaned.length <= 10) {
//             setFormState({ ...formState, [name]: cleaned });
//         }
//         return;
//     }
//     setFormState({ ...formState, [name]: value });
//   };

//   const validateForm = () => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const phoneRegex = /^\d{10}$/;

//     if (!emailRegex.test(formState.email)) {
//       toast.error("Please enter a valid email address with '@'");
//       return false;
//     }
//     if (!phoneRegex.test(formState.phoneNumber)) {
//       toast.error("Phone number must be exactly 10 digits");
//       return false;
//     }
//     if (formState.fullName.trim().length < 2) {
//       toast.error("Please enter your full name");
//       return false;
//     }
//     // Final check for Captcha
//     if (userInputCaptcha.toUpperCase() !== captchaText) {
//       toast.error("Incorrect security code. Please try again.");
//       generateCaptcha();
//       return false;
//     }
//     return true;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!validateForm()) return;

//     setIsSubmitting(true);
//     try {
//       const response = await fetch(`${API_URL}/api/public/contact`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formState),
//       });
      
//       const result = await response.json();

//       if (response.ok && result.success) {
//         setIsSubmitted(true);
//         toast.success(result.message || "Request sent successfully!");
//         setFormState({ fullName: '', email: '', phoneNumber: '', subject: 'IVR Inquiry', message: '' });
//         generateCaptcha();
//       } else {
//         toast.error(result.message || "Something went wrong. Please try again.");
//         generateCaptcha();
//       }
//     } catch (error) { 
//       console.error(error); 
//       toast.error("Failed to connect to the server.");
//     } 
//     finally { setIsSubmitting(false); }
//   };

//   const bgPuzzleStyle = {
//     backgroundImage: `linear-gradient(#0C4550 1px, transparent 1px), linear-gradient(90deg, #0C4550 1px, transparent 1px)`,
//     backgroundSize: '30px 30px',
//   };

//   return (
//     <>
//       <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} />
//       {/* --- HERO SECTION --- */}
//       <section className="bg-[#EEF2FC] flex flex-col md:flex-row items-center justify-between px-6 py-10 md:px-12 lg:px-24">
//         <div className="w-full md:w-1/2 mb-10 md:mb-0 md:pr-10">
//           <h1 className="text-4xl md:text-5xl font-medium text-slate-900 leading-tight tracking-tight mb-6">
//             Seamless IVR Services for Your Business
//           </h1>
//           <p className="text-lg text-slate-700 mb-8 leading-relaxed">
//             Elevate your customer support experience with our advanced Interactive Voice Response services. 
//             We provide intelligent call routing, 24/7 automated assistance, and custom voice flows designed 
//             to streamline communication and boost customer satisfaction. Our IVR solution are widely used in businesses of every industry in PAN India.
//           </p>
//           <a 
//             href="#contact-start" 
//             className="inline-flex items-center gap-2 px-6 py-3 text-white bg-slate-900 rounded-lg transition duration-300 shadow-md "
//           >
//             Request a Demo
//             <ChevronDown className="w-5 h-5 animate-bounce" />
//           </a>
//         </div>
//         <div className="w-full md:w-1/2 flex justify-center">
//           <img src={Image1} alt="IVR Services Illustration" className="w-full max-w-lg h-auto" />
//         </div>
//       </section>

//       {/* --- SECTION 2: What is IVR --- */}
//       <section className="bg-[#EEF2FC] px-6 py-16 md:px-12 lg:px-24">
//         <div className="text-center mb-12">
//           <h2 className="text-3xl md:text-4xl font-semibold text-slate-900">Interactive Voice Response (IVR)</h2>
//           <div className="w-24 h-1 bg-slate-900 mx-auto mt-4 rounded-full"></div>
//         </div>
//         <div className="flex flex-col md:flex-row items-center gap-12">
//           <div className="w-full md:w-1/2 flex justify-center md:justify-start">
//             <img src={Image2} alt="IVR Technology Details" className="w-full h-auto rounded-xl object-cover" />
//           </div>
//           <div className="w-full md:w-1/2">
//             <h3 className="text-2xl font-medium text-slate-900 mb-4">What is IVR?</h3>
//             <p className="text-lg text-slate-700 mb-6 leading-relaxed">
//               Interactive Voice Response (IVR) is an automated telephony system that interacts with callers, gathers information, and routes calls to the appropriate recipients...
//             </p>
//             <p className="text-lg text-slate-700 mb-6 leading-relaxed">
//               Our IVR solution are used in a variety of sectors including telecommunications, banking, educational, healthcare, retail, and government...
//             </p>
//             <ul className="space-y-3">
//               <li className="flex items-center text-slate-700"><span className="w-2 h-2 bg-[#F46653] rounded-full mr-3"></span>Reduce customer wait times significantly.</li>
//               <li className="flex items-center text-slate-700"><span className="w-2 h-2 bg-[#F46653] rounded-full mr-3"></span>Provide 24/7 support availability.</li>
//               <li className="flex items-center text-slate-700"><span className="w-2 h-2 bg-[#F46653] rounded-full mr-3"></span>Professionalize your business image.</li>
//             </ul>
//           </div>
//         </div>
//       </section>

//       {/* --- SECTION 3: Key Features --- */}
//       <section className="bg-[#EEF2FC] px-6 py-16 md:px-12 lg:px-24">
//         <div className="text-center mb-12">
//           <h2 className="text-3xl md:text-4xl font-semibold text-slate-900">Key Features of Our IVR Solution</h2>
//           <div className="w-24 h-1 bg-slate-900 mx-auto mt-4 rounded-full"></div>
//         </div>
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//           {features.map((type) => (
//             <div key={type.id} className={`flex items-start ${type.gradient} shadow-lg p-8 rounded-xl border-l-4 border-slate-900 transition-transform duration-300 hover:-translate-y-2 hover:shadow-xl`}>
//               <FontAwesomeIcon icon={type.icon} size="2x" className="text-slate-900 mr-6 mt-1" />
//               <div>
//                 <h4 className="text-xl font-semibold text-slate-900 mb-3">{type.title}</h4>
//                 <p className="text-slate-700 leading-relaxed text-base">{type.description}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* --- SECTION 4: How IVR Works --- */}
//       <section className="bg-[#EEF2FC] px-6 py-16 md:px-12 lg:px-24">
//         <div className="text-center mb-16">
//           <h2 className="text-3xl md:text-4xl font-semibold text-slate-900">How IVR Works?</h2>
//           <div className="w-24 h-1 bg-slate-900 mx-auto mt-4 rounded-full"></div>
//         </div>
//         <div className="relative max-w-5xl mx-auto">
//           <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-[#0C4550]"></div>
//           {workingSteps.map((step, index) => (
//             <div key={step.id} className="flex flex-col md:flex-row items-center justify-between w-full mb-8 relative">
//               <div className="w-full md:w-5/12 mb-4 md:mb-0">
//                 {index % 2 !== 0 && (
//                   <div className="bg-white p-6 rounded-lg shadow-md border-t-4 border-slate-900 transition-transform duration-300 hover:-translate-y-2 hover:shadow-xl">
//                     <div className="flex items-center gap-4 mb-3">
//                         <div className={`w-10 h-10 rounded-full ${step.gradient} flex items-center justify-center shrink-0`}>
//                           <FontAwesomeIcon icon={step.icon} className="text-slate-900 text-lg" />
//                         </div>
//                         <h3 className="text-xl font-semibold text-slate-900">{step.title}</h3>
//                     </div>
//                     <p className="text-slate-600 text-sm leading-relaxed">{step.description}</p>
//                   </div>
//                 )}
//               </div>
//               <div className="z-10 flex items-center justify-center w-8 h-8 bg-[#F46653] rounded-full border-4 border-white ring-2 ring-[#0C4550] animate-pulse"></div>
//               <div className="w-full md:w-5/12 mt-4 md:mt-0">
//                 {index % 2 === 0 && (
//                   <div className="bg-white p-6 rounded-lg shadow-md border-t-4 border-slate-900 transition-transform duration-300 hover:-translate-y-2 hover:shadow-xl">
//                       <div className="flex items-center gap-4 mb-3">
//                         <div className={`w-10 h-10 rounded-full ${step.gradient} flex items-center justify-center shrink-0`}>
//                             <FontAwesomeIcon icon={step.icon} className="text-slate-900 text-lg" />
//                         </div>
//                         <h3 className="text-xl font-semibold text-slate-900">{step.title}</h3>
//                     </div>
//                     <p className="text-slate-600 text-sm leading-relaxed">{step.description}</p>
//                   </div>
//                 )}
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* --- SECTION 5: Types of IVR --- */}
//       <section className="bg-[#EEF2FC] py-20 px-6 md:px-12 lg:px-24 overflow-hidden">
//           <div className="text-center mb-20">
//             <h2 className="text-3xl md:text-4xl font-semibold text-slate-900">Types of IVR Solution</h2>
//             <div className="w-24 h-1 bg-slate-900 mx-auto mt-4 rounded-full"></div>
//           </div>
//           <div className="relative max-w-7xl mx-auto">
//             <svg className="hidden md:block absolute top-[20px] left-0 w-full h-28 z-0" viewBox="0 0 1200 100" preserveAspectRatio="none">
//               <path d="M0,50 C400,0 800,100 1200,50" stroke="#cbd5e1" strokeWidth="3" strokeDasharray="12 12" fill="none" />
//             </svg>
//              <div className="hidden md:block absolute top-[45px] -right-4 transform -translate-y-1/2 z-0 text-[#F46653]">
//                 <FontAwesomeIcon icon={faPaperPlane} size="lg" className="transform -rotate-12" />
//              </div>
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-6 relative z-10">
//               {ivrTypes.map((item) => (
//                 <div key={item.id} className="flex flex-col items-center text-center">
//                   <div className="relative mb-8">
//                     <div className="w-36 h-36 rounded-full bg-white shadow-lg flex items-center justify-center border-4 border-white z-10 relative overflow-hidden">
//                         <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
//                     </div>
//                     <div className="absolute bottom-1 right-2 w-10 h-10 bg-[#F46653] rounded-full text-white font-bold flex items-center justify-center border-4 border-white shadow-sm z-20">{item.id}</div>
//                   </div>
//                   <h3 className="text-xl font-bold text-slate-800 mb-4">{item.title}</h3>
//                   <p className="text-slate-600 text-sm leading-relaxed px-4">{item.description}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//       </section>

//       {/* --- CONTACT SECTION --- */}
//       <section id="contact-start" className="py-16 relative overflow-hidden">
//         <div className="absolute inset-0 z-0" style={bgPuzzleStyle}></div>
//         <div className="absolute inset-0 bg-gradient-to-br from-[#0C4550] via-[#0C4550] to-[#09333c] opacity-95"></div>
        
//         <div className="container mx-auto px-4 relative z-10">
//           <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={containerVariants} className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 max-w-6xl mx-auto items-start">
//             {/* LEFT SIDE */}
//             <motion.div variants={itemVariants} className="space-y-8">
//               <div>
//                 <div className="inline-flex items-center gap-2 mb-2">
//                   <div className="w-2.5 h-2.5 bg-[#F46653] rounded-full"></div>
//                   <span className="text-white/80 font-semibold text-xs uppercase tracking-widest">Get in Touch</span>
//                 </div>
//                 <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">Request a <span className="text-[#F46653]"> IVR Demo</span></h2>
//                 <p className="text-white/70 text-base leading-relaxed">Our dedicated support team is available 24/7 to assist with your business communication needs.</p>
//               </div>

//               <div className="space-y-3">
//                 <ContactDetail icon={Phone} title="Phone Support" content="+91-9717055088" subContent="24/7 Support Available" />
//                 <ContactDetail icon={Mail} title="Email Address" content="info@deetyasoft.com" subContent="support@eurofox.com" />
//                 <ContactDetail icon={MapPin} title="Location" content="Abhay Khand -2, Indirapuram" subContent="Ghaziabad, Uttar Pradesh" />
//                 <ContactDetail icon={Clock} title="Business Hours" content="Mon - Sat: 10AM - 6PM" subContent="24/7 Emergency Support" />
//               </div>

//               <motion.div variants={itemVariants} className="pt-4 border-t border-white/20">
//                 <p className="text-white text-base font-bold mb-2">Connect With Us -</p>
//                 <div className="flex gap-3">
//                   {[Linkedin, Twitter, Facebook, Instagram].map((Icon, idx) => (
//                     <motion.a key={idx} whileHover={{ y: -3 }} href="#" className="p-2 bg-white/10 hover:bg-white/20 rounded-lg text-white group">
//                       <Icon className="w-4 h-4 group-hover:text-[#F46653] transition-colors" />
//                     </motion.a>
//                   ))}
//                 </div>
//               </motion.div>
//             </motion.div>

//             {/* RIGHT SIDE - FORM */}
//             <motion.div variants={itemVariants}>
//               <div className="bg-white rounded-3xl shadow-2xl p-8">
//                 <AnimatePresence mode="wait">
//                   {isSubmitted ? (
//                     <motion.div key="success" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} className="text-center py-12">
//                       <CheckCircle2 className="w-20 h-20 text-green-500 mx-auto mb-6" />
//                       <h3 className="text-3xl font-bold text-gray-800 mb-4">Request Sent!</h3>
//                       <p className="text-gray-600 mb-8">Our team will get back to you within 2 hours to schedule your demo.</p>
//                       <button onClick={() => setIsSubmitted(false)} className="px-8 py-3 bg-[#0C4550] text-white font-semibold rounded-xl">Send Another</button>
//                     </motion.div>
//                   ) : (
//                     <motion.div key="form">
//                       <div className="flex items-center gap-3 mb-6">
//                         <div className="p-3 bg-[#0C4550]/10 rounded-xl"><MessageSquare className="w-6 h-6 text-[#0C4550]" /></div>
//                         <div>
//                             <p className="text-2xl font-bold text-gray-800">Send Us a Message</p>
//                             <p className="text-gray-500 text-sm">Fill out the form below and we'll respond promptly</p>
//                         </div>
//                       </div>
//                       <form onSubmit={handleSubmit} className="space-y-5">
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//                           <InputField label="Full Name" name="fullName" value={formState.fullName} onChange={handleChange} placeholder="Your Name" required />
//                           <InputField label="Email Address" type="email" name="email" value={formState.email} onChange={handleChange} placeholder="Your Email" required />
//                         </div>
                        
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//                           <InputField label="Phone Number" type="tel" name="phoneNumber" value={formState.phoneNumber} onChange={handleChange} placeholder="Enter your digits" required />
//                           <InputField 
//                             label="Subject" 
//                             name="subject" 
//                             value="IVR Inquiry" 
//                             readOnly={true} 
//                           />
//                         </div>

//                         <TextArea label="Your Message" name="message" value={formState.message} onChange={handleChange} placeholder="Tell us about your requirements..." required />

//                         {/* --- ADDED CAPTCHA FIELD --- */}
//                         <div className="flex flex-col space-y-1.5 pt-2">
//                           <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">Security Check</label>
//                           <div className="flex items-center gap-4">
//                             <div className="flex items-center justify-center bg-gray-100 border-2 border-dashed border-gray-300 rounded-xl px-6 py-3 select-none">
//                               <span className="text-xl font-black tracking-[0.3em] text-[#0C4550] italic line-through decoration-[#F46653]/40">
//                                 {captchaText}
//                               </span>
//                             </div>
//                             <button 
//                               type="button" 
//                               onClick={generateCaptcha} 
//                               className="p-2 hover:bg-gray-100 rounded-full transition-colors"
//                               title="Refresh Code"
//                             >
//                               <RefreshCcw className="w-5 h-5 text-gray-500" />
//                             </button>
//                             <div className="flex-1">
//                               <input
//                                 type="text"
//                                 placeholder="Enter code"
//                                 value={userInputCaptcha}
//                                 onChange={(e) => setUserInputCaptcha(e.target.value.toUpperCase())}
//                                 className="w-full px-5 py-3 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all"
//                                 required
//                               />
//                             </div>
//                           </div>
//                         </div>

//                         <div className="flex items-center justify-between pt-2">
//                             <motion.button 
//                                 disabled={isSubmitting || userInputCaptcha.length < 6} 
//                                 whileHover={{ scale: isSubmitting ? 1 : 1.02 }} 
//                                 whileTap={{ scale: isSubmitting ? 1 : 0.98 }} 
//                                 type="submit" 
//                                 className="w-full py-3.5 bg-gradient-to-r from-[#0C4550] to-[#F46653] text-white font-bold rounded-xl flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
//                             >
//                                 {isSubmitting ? (
//                                     <>Processing... <Loader2 className="w-5 h-5 animate-spin" /></>
//                                 ) : (
//                                     <>Send Message <Send className="w-5 h-5" /></>
//                                 )}
//                             </motion.button>
//                         </div>
//                       </form>
//                     </motion.div>
//                   )}
//                 </AnimatePresence>
//               </div>
//             </motion.div>
//           </motion.div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Ivr;




import React, { useState, useEffect } from 'react'; // Added useEffect
import { Link } from 'react-router-dom'; // Added Link import for routing
import { motion, AnimatePresence } from 'framer-motion';
// Import Toast components
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { 
  Phone, Mail, MapPin, Send, MessageSquare, 
  Clock, CheckCircle2, Linkedin, Twitter, 
  Facebook, Instagram, Loader2, ChevronDown,
  RefreshCcw // Added for captcha refresh
} from 'lucide-react';

import Image1 from "../../assets/ivr.webp";
import Image2 from "../../assets/ivr2.webp";

// 1. Import FontAwesome components and icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhoneVolume,
  faUserGear,
  faMicrophone,
  faPlayCircle,
  faListUl,
  faCloudArrowDown,
  faPhone,
  faKeyboard,
  faHeadset,
  faPhoneSlash,
  faPaperPlane, 
} from "@fortawesome/free-solid-svg-icons";

import HostedImg from "../../assets/ivr3.png"
import OnPremiseImg from "../../assets/ivr4.png"
import AutomatedImg from "../../assets/ivr5.png"
import { API_URL } from '../../../Constants';

// --- Contact Section Helpers ---
const containerVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.1, delayChildren: 0.1 } }
};

const itemVariants = {
  hidden: { opacity: 0, y: 15 },
  visible: { opacity: 1, y: 0, transition: { type: "spring", stiffness: 100, damping: 20 } }
};

const InputField = ({ label, type = "text", placeholder, name, value, onChange, required, readOnly, className }) => (
  <div className="flex flex-col space-y-1.5">
    <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      readOnly={readOnly}
      className={`w-full px-5 py-3.5 text-sm md:text-base rounded-xl border transition-all duration-300 focus:outline-none ${
        readOnly 
        ? "bg-gray-100 border-gray-200 text-gray-500 cursor-not-allowed" 
        : "bg-gray-50 border-gray-200 text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550]"
      } ${className}`}
    />
  </div>
);

const TextArea = ({ label, placeholder, name, value, onChange, required }) => (
  <div className="flex flex-col space-y-1.5">
    <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
    <textarea
      name={name}
      value={value}
      onChange={onChange}
      rows="4"
      placeholder={placeholder}
      required={required}
      className="w-full px-5 py-3.5 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all duration-300 resize-none"
    />
  </div>
);

const ContactDetail = ({ icon: Icon, title, content, subContent }) => (
  <motion.div variants={itemVariants} className="flex items-start gap-3 p-2 rounded-xl hover:bg-white/10 transition-colors duration-300 group cursor-default">
    <div className="p-2 bg-white/10 rounded-lg group-hover:bg-[#F46653] transition-colors duration-300 shadow-sm">
      <Icon className="text-white w-4 h-4" />
    </div>
    <div>
      <h4 className="text-white/60 text-[10px] font-medium uppercase tracking-wider mb-0">{title}</h4>
      <p className="text-white text-base font-bold leading-tight">{content}</p>
      {subContent && <p className="text-white/70 text-xs mt-0">{subContent}</p>}
    </div>
  </motion.div>
);

export const Ivr = () => {
  const features = [
    { id: 1, icon: faPhoneVolume, title: "Call Routing", description: `Routing calls to the appropriate department or individual based on the caller's selection. A customer calls a company and an IVR system greets them. The system might say, "Press 1 for sales, 2 for support, 3 for billing." Based on the caller's selection, the call is routed appropriately.`, gradient: "bg-gradient-to-br from-blue-100 to-indigo-50" },
    { id: 2, icon: faUserGear, title: "Self-Service Options", description: `Our IVR solution allows you to access self-services such as checking account balances, paying bills, or updating personal information without the need for speaking with a live representative.`, gradient: "bg-gradient-to-br from-emerald-50 to-teal-50" },
    { id: 3, icon: faMicrophone, title: "Speech Recognition", description: `With speech recognition technology, our IVR solution enabling callers to speak their responses instead of using a keypad. This creates a more seamless and natural interaction, reducing frustration and improving overall experience.`, gradient: "bg-gradient-to-br from-purple-50 to-fuchsia-50" },
    { id: 4, icon: faPlayCircle, title: "Pre-recorded Messages", description: `Pre-recorded voice messages guide the caller through the available options. These can be customized to suit the specific needs of a business and can include multi-lingual prompts for diverse customer bases.`, gradient: "bg-gradient-to-br from-amber-50 to-orange-50" },
    { id: 5, icon: faListUl, title: "Multi-level Menus", description: `Our IVR solution provides you multi-level menus where users can drill down through several options to access more specific services. For instance, after selecting “customer service”, callers may be asked to select a specific issue.`, gradient: "bg-gradient-to-br from-rose-50 to-pink-50" },
    { id: 6, icon: faCloudArrowDown, title: "Real-Time Data Integration", description: `Our IVR solution can integrate with backend databases or CRM (Customer Relationship Management) systems to provide real-time information. For example, accessing a customer’s account details in real-time to provide balance information.`, gradient: "bg-gradient-to-br from-cyan-50 to-sky-50" },
  ];

  const workingSteps = [
    { id: 1, icon: faPhone, title: "Call Initiation", description: "A customer calls a business and is greeted by the IVR system, which plays a recorded greeting and presents options through voice prompts.", gradient: "bg-gradient-to-br from-blue-100 to-indigo-50" },
    { id: 2, icon: faKeyboard, title: "Input from Customer", description: "The caller interacts with the system by pressing keys on their phone (Dual-Tone Multi-Frequency or DTMF) or speaking their choices if speech recognition is enabled.", gradient: "bg-gradient-to-br from-emerald-50 to-teal-50" },
    { id: 3, icon: faMicrophone, title: "Processing Input", description: "The IVR system processes the input (whether keypad selection or voice command) and determines the appropriate action, such as routing the call or providing information.", gradient: "bg-gradient-to-br from-purple-50 to-fuchsia-50" },
    { id: 4, icon: faHeadset, title: "Completion or Further Interaction", description: "The system either completes the transaction or continues interacting to gather details. If necessary, the call is transferred to a live representative.", gradient: "bg-gradient-to-br from-amber-50 to-orange-50" },
    { id: 5, icon: faPhoneSlash, title: "End of Call", description: "Once the query is resolved or the transaction is completed, the call is disconnected automatically or by the user.", gradient: "bg-gradient-to-br from-rose-50 to-pink-50" },
  ];

  const ivrTypes = [
    { id: "01", image: HostedImg, title: "Hosted IVR (Cloud-based IVR)", description: "A cloud-based or hosted IVR system is managed off-site by a third-party provider. This eliminates the need for businesses to invest in on-premise infrastructure and allows for easier scalability. Hosted IVR is popular among businesses that need flexible, cost-effective solutions." },
    { id: "02", image: OnPremiseImg, title: "On-premise IVR", description: "On-premise IVR solutions are installed within a company's infrastructure. These solutions provide more control and customization options but come with higher upfront costs and maintenance requirements." },
    { id: "03", image: AutomatedImg, title: "Automated IVR", description: "An automated IVR system operates without human intervention, automating the entire call process. It includes routine customer service interactions like checking balances or processing payments." },
  ];

  // Updated formState keys to match API
  const [formState, setFormState] = useState({ fullName: '', email: '', phoneNumber: '', subject: 'IVR Inquiry', message: '' });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [consentGiven, setConsentGiven] = useState(false); // Added consent state

  // --- CAPTCHA LOGIC ---
  const [captchaText, setCaptchaText] = useState('');
  const [userInputCaptcha, setUserInputCaptcha] = useState('');

  const generateCaptcha = () => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789"; 
    let result = "";
    for (let i = 0; i < 6; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptchaText(result);
    setUserInputCaptcha('');
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'phoneNumber') {
        const cleaned = value.replace(/\D/g, ''); 
        if (cleaned.length <= 10) {
            setFormState({ ...formState, [name]: cleaned });
        }
        return;
    }
    setFormState({ ...formState, [name]: value });
  };

  const validateForm = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;

    if (!emailRegex.test(formState.email)) {
      toast.error("Please enter a valid email address with '@'");
      return false;
    }
    if (!phoneRegex.test(formState.phoneNumber)) {
      toast.error("Phone number must be exactly 10 digits");
      return false;
    }
    if (formState.fullName.trim().length < 2) {
      toast.error("Please enter your full name");
      return false;
    }
    if (!consentGiven) { // Final check for Consent
      toast.error("Please agree to the Terms & Conditions and Privacy Policy.");
      return false;
    }
    // Final check for Captcha
    if (userInputCaptcha.toUpperCase() !== captchaText) {
      toast.error("Incorrect security code. Please try again.");
      generateCaptcha();
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    setIsSubmitting(true);
    try {
      const response = await fetch(`${API_URL}/api/public/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formState),
      });
      
      const result = await response.json();

      if (response.ok && result.success) {
        setIsSubmitted(true);
        toast.success(result.message || "Request sent successfully!");
        setFormState({ fullName: '', email: '', phoneNumber: '', subject: 'IVR Inquiry', message: '' });
        setConsentGiven(false); // Reset consent after success
        generateCaptcha();
      } else {
        toast.error(result.message || "Something went wrong. Please try again.");
        generateCaptcha();
      }
    } catch (error) { 
      console.error(error); 
      toast.error("Failed to connect to the server.");
    } 
    finally { setIsSubmitting(false); }
  };

  const bgPuzzleStyle = {
    backgroundImage: `linear-gradient(#0C4550 1px, transparent 1px), linear-gradient(90deg, #0C4550 1px, transparent 1px)`,
    backgroundSize: '30px 30px',
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} />
      {/* --- HERO SECTION --- */}
      <section className="bg-[#EEF2FC] flex flex-col md:flex-row items-center justify-between px-6 py-10 md:px-12 lg:px-24">
        <div className="w-full md:w-1/2 mb-10 md:mb-0 md:pr-10">
          <h1 className="text-4xl md:text-5xl font-medium text-slate-900 leading-tight tracking-tight mb-6">
            Seamless IVR Services for Your Business
          </h1>
          <p className="text-lg text-slate-700 mb-8 leading-relaxed">
            Elevate your customer support experience with our advanced Interactive Voice Response services. 
            We provide intelligent call routing, 24/7 automated assistance, and custom voice flows designed 
            to streamline communication and boost customer satisfaction. Our IVR solution are widely used in businesses of every industry in PAN India.
          </p>
          <a 
            href="#contact-start" 
            className="inline-flex items-center gap-2 px-6 py-3 text-white bg-slate-900 rounded-lg transition duration-300 shadow-md "
          >
            Request a Demo
            <ChevronDown className="w-5 h-5 animate-bounce" />
          </a>
        </div>
        <div className="w-full md:w-1/2 flex justify-center">
          <img src={Image1} alt="IVR Services Illustration" className="w-full max-w-lg h-auto" />
        </div>
      </section>

      {/* --- SECTION 2: What is IVR --- */}
      <section className="bg-[#EEF2FC] px-6 py-16 md:px-12 lg:px-24">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-semibold text-slate-900">Interactive Voice Response (IVR)</h2>
          <div className="w-24 h-1 bg-slate-900 mx-auto mt-4 rounded-full"></div>
        </div>
        <div className="flex flex-col md:flex-row items-center gap-12">
          <div className="w-full md:w-1/2 flex justify-center md:justify-start">
            <img src={Image2} alt="IVR Technology Details" className="w-full h-auto rounded-xl object-cover" />
          </div>
          <div className="w-full md:w-1/2">
            <h3 className="text-2xl font-medium text-slate-900 mb-4">What is IVR?</h3>
            <p className="text-lg text-slate-700 mb-6 leading-relaxed">
              Interactive Voice Response (IVR) is an automated telephony system that interacts with callers, gathers information, and routes calls to the appropriate recipients...
            </p>
            <p className="text-lg text-slate-700 mb-6 leading-relaxed">
              Our IVR solution are used in a variety of sectors including telecommunications, banking, educational, healthcare, retail, and government...
            </p>
            <ul className="space-y-3">
              <li className="flex items-center text-slate-700"><span className="w-2 h-2 bg-[#F46653] rounded-full mr-3"></span>Reduce customer wait times significantly.</li>
              <li className="flex items-center text-slate-700"><span className="w-2 h-2 bg-[#F46653] rounded-full mr-3"></span>Provide 24/7 support availability.</li>
              <li className="flex items-center text-slate-700"><span className="w-2 h-2 bg-[#F46653] rounded-full mr-3"></span>Professionalize your business image.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* --- SECTION 3: Key Features --- */}
      <section className="bg-[#EEF2FC] px-6 py-16 md:px-12 lg:px-24">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-semibold text-slate-900">Key Features of Our IVR Solution</h2>
          <div className="w-24 h-1 bg-slate-900 mx-auto mt-4 rounded-full"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((type) => (
            <div key={type.id} className={`flex items-start ${type.gradient} shadow-lg p-8 rounded-xl border-l-4 border-slate-900 transition-transform duration-300 hover:-translate-y-2 hover:shadow-xl`}>
              <FontAwesomeIcon icon={type.icon} size="2x" className="text-slate-900 mr-6 mt-1" />
              <div>
                <h4 className="text-xl font-semibold text-slate-900 mb-3">{type.title}</h4>
                <p className="text-slate-700 leading-relaxed text-base">{type.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* --- SECTION 4: How IVR Works --- */}
      <section className="bg-[#EEF2FC] px-6 py-16 md:px-12 lg:px-24">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-semibold text-slate-900">How IVR Works?</h2>
          <div className="w-24 h-1 bg-slate-900 mx-auto mt-4 rounded-full"></div>
        </div>
        <div className="relative max-w-5xl mx-auto">
          <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-[#0C4550]"></div>
          {workingSteps.map((step, index) => (
            <div key={step.id} className="flex flex-col md:flex-row items-center justify-between w-full mb-8 relative">
              <div className="w-full md:w-5/12 mb-4 md:mb-0">
                {index % 2 !== 0 && (
                  <div className="bg-white p-6 rounded-lg shadow-md border-t-4 border-slate-900 transition-transform duration-300 hover:-translate-y-2 hover:shadow-xl">
                    <div className="flex items-center gap-4 mb-3">
                        <div className={`w-10 h-10 rounded-full ${step.gradient} flex items-center justify-center shrink-0`}>
                          <FontAwesomeIcon icon={step.icon} className="text-slate-900 text-lg" />
                        </div>
                        <h3 className="text-xl font-semibold text-slate-900">{step.title}</h3>
                    </div>
                    <p className="text-slate-600 text-sm leading-relaxed">{step.description}</p>
                  </div>
                )}
              </div>
              <div className="z-10 flex items-center justify-center w-8 h-8 bg-[#F46653] rounded-full border-4 border-white ring-2 ring-[#0C4550] animate-pulse"></div>
              <div className="w-full md:w-5/12 mt-4 md:mt-0">
                {index % 2 === 0 && (
                  <div className="bg-white p-6 rounded-lg shadow-md border-t-4 border-slate-900 transition-transform duration-300 hover:-translate-y-2 hover:shadow-xl">
                      <div className="flex items-center gap-4 mb-3">
                        <div className={`w-10 h-10 rounded-full ${step.gradient} flex items-center justify-center shrink-0`}>
                            <FontAwesomeIcon icon={step.icon} className="text-slate-900 text-lg" />
                        </div>
                        <h3 className="text-xl font-semibold text-slate-900">{step.title}</h3>
                    </div>
                    <p className="text-slate-600 text-sm leading-relaxed">{step.description}</p>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* --- SECTION 5: Types of IVR --- */}
      <section className="bg-[#EEF2FC] py-20 px-6 md:px-12 lg:px-24 overflow-hidden">
          <div className="text-center mb-20">
            <h2 className="text-3xl md:text-4xl font-semibold text-slate-900">Types of IVR Solution</h2>
            <div className="w-24 h-1 bg-slate-900 mx-auto mt-4 rounded-full"></div>
          </div>
          <div className="relative max-w-7xl mx-auto">
            <svg className="hidden md:block absolute top-[20px] left-0 w-full h-28 z-0" viewBox="0 0 1200 100" preserveAspectRatio="none">
              <path d="M0,50 C400,0 800,100 1200,50" stroke="#cbd5e1" strokeWidth="3" strokeDasharray="12 12" fill="none" />
            </svg>
             <div className="hidden md:block absolute top-[45px] -right-4 transform -translate-y-1/2 z-0 text-[#F46653]">
                <FontAwesomeIcon icon={faPaperPlane} size="lg" className="transform -rotate-12" />
             </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-6 relative z-10">
              {ivrTypes.map((item) => (
                <div key={item.id} className="flex flex-col items-center text-center">
                  <div className="relative mb-8">
                    <div className="w-36 h-36 rounded-full bg-white shadow-lg flex items-center justify-center border-4 border-white z-10 relative overflow-hidden">
                        <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
                    </div>
                    <div className="absolute bottom-1 right-2 w-10 h-10 bg-[#F46653] rounded-full text-white font-bold flex items-center justify-center border-4 border-white shadow-sm z-20">{item.id}</div>
                  </div>
                  <h3 className="text-xl font-bold text-slate-800 mb-4">{item.title}</h3>
                  <p className="text-slate-600 text-sm leading-relaxed px-4">{item.description}</p>
                </div>
              ))}
            </div>
          </div>
      </section>

      {/* --- CONTACT SECTION --- */}
      <section id="contact-start" className="py-16 relative overflow-hidden">
        <div className="absolute inset-0 z-0" style={bgPuzzleStyle}></div>
        <div className="absolute inset-0 bg-gradient-to-br from-[#0C4550] via-[#0C4550] to-[#09333c] opacity-95"></div>
        
        <div className="container mx-auto px-4 relative z-10">
          <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={containerVariants} className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 max-w-6xl mx-auto items-start">
            {/* LEFT SIDE */}
            <motion.div variants={itemVariants} className="space-y-8">
              <div>
                <div className="inline-flex items-center gap-2 mb-2">
                  <div className="w-2.5 h-2.5 bg-[#F46653] rounded-full"></div>
                  <span className="text-white/80 font-semibold text-xs uppercase tracking-widest">Get in Touch</span>
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">Request a <span className="text-[#F46653]"> IVR Demo</span></h2>
                <p className="text-white/70 text-base leading-relaxed">Our dedicated support team is available 24/7 to assist with your business communication needs.</p>
              </div>

              <div className="space-y-3">
                <ContactDetail icon={Phone} title="Phone Support" content="+91-9717055088" subContent="24/7 Support Available" />
                <ContactDetail icon={Mail} title="Email Address" content="info@deetyasoft.com" subContent="support@eurofox.com" />
                <ContactDetail icon={MapPin} title="Location" content="Abhay Khand -2, Indirapuram" subContent="Ghaziabad, Uttar Pradesh" />
                <ContactDetail icon={Clock} title="Business Hours" content="Mon - Sat: 10AM - 6PM" subContent="24/7 Emergency Support" />
              </div>

              <motion.div variants={itemVariants} className="pt-4 border-t border-white/20">
                <p className="text-white text-base font-bold mb-2">Connect With Us -</p>
                <div className="flex gap-3">
                  {[Linkedin, Twitter, Facebook, Instagram].map((Icon, idx) => (
                    <motion.a key={idx} whileHover={{ y: -3 }} href="#" className="p-2 bg-white/10 hover:bg-white/20 rounded-lg text-white group">
                      <Icon className="w-4 h-4 group-hover:text-[#F46653] transition-colors" />
                    </motion.a>
                  ))}
                </div>
              </motion.div>
            </motion.div>

            {/* RIGHT SIDE - FORM */}
            <motion.div variants={itemVariants}>
              <div className="bg-white rounded-3xl shadow-2xl p-8">
                <AnimatePresence mode="wait">
                  {isSubmitted ? (
                    <motion.div key="success" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} className="text-center py-12">
                      <CheckCircle2 className="w-20 h-20 text-green-500 mx-auto mb-6" />
                      <h3 className="text-3xl font-bold text-gray-800 mb-4">Request Sent!</h3>
                      <p className="text-gray-600 mb-8">Our team will get back to you within 2 hours to schedule your demo.</p>
                      <button onClick={() => setIsSubmitted(false)} className="px-8 py-3 bg-[#0C4550] text-white font-semibold rounded-xl">Send Another</button>
                    </motion.div>
                  ) : (
                    <motion.div key="form">
                      <div className="flex items-center gap-3 mb-6">
                        <div className="p-3 bg-[#0C4550]/10 rounded-xl"><MessageSquare className="w-6 h-6 text-[#0C4550]" /></div>
                        <div>
                            <p className="text-2xl font-bold text-gray-800">Send Us a Message</p>
                            <p className="text-gray-500 text-sm">Fill out the form below and we'll respond promptly</p>
                        </div>
                      </div>
                      <form onSubmit={handleSubmit} className="space-y-5">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                          <InputField label="Full Name" name="fullName" value={formState.fullName} onChange={handleChange} placeholder="Your Name" required />
                          <InputField label="Email Address" type="email" name="email" value={formState.email} onChange={handleChange} placeholder="Your Email" required />
                        </div>
                        
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                          <InputField label="Phone Number" type="tel" name="phoneNumber" value={formState.phoneNumber} onChange={handleChange} placeholder="Enter your digits" required />
                          <InputField 
                            label="Subject" 
                            name="subject" 
                            value="IVR Inquiry" 
                            readOnly={true} 
                          />
                        </div>

                        <TextArea label="Your Message" name="message" value={formState.message} onChange={handleChange} placeholder="Tell us about your requirements..." required />

                        {/* --- SECURITY CODE / CAPTCHA FIELD --- */}
                        <div className="flex flex-col space-y-1.5 pt-2">
                          <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">Security Check</label>
                          <div className="flex items-center gap-4">
                            <div className="flex items-center justify-center bg-gray-100 border-2 border-dashed border-gray-300 rounded-xl px-6 py-3 select-none">
                              <span className="text-xl font-black tracking-[0.3em] text-[#0C4550] italic line-through decoration-[#F46653]/40">
                                {captchaText}
                              </span>
                            </div>
                            <button 
                              type="button" 
                              onClick={generateCaptcha} 
                              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                              title="Refresh Code"
                            >
                              <RefreshCcw className="w-5 h-5 text-gray-500" />
                            </button>
                            <div className="flex-1">
                              <input
                                type="text"
                                placeholder="Enter code"
                                value={userInputCaptcha}
                                onChange={(e) => setUserInputCaptcha(e.target.value.toUpperCase())}
                                className="w-full px-5 py-3 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        {/* --- CONSENT CHECKBOX --- */}
                        <div className="flex items-start gap-3 pt-2">
                          <input
                            type="checkbox"
                            id="consent"
                            checked={consentGiven}
                            onChange={(e) => setConsentGiven(e.target.checked)}
                            className="mt-1 min-w-[1rem] w-4 h-4 text-[#0C4550] border-gray-300 rounded focus:ring-[#0C4550] cursor-pointer"
                            required
                          />
                          <label htmlFor="consent" className="text-sm text-gray-600 leading-relaxed cursor-pointer select-none">
                            I agree to the <Link to="/terms-and-conditions" onClick={(e) => e.stopPropagation()} className="text-blue-600 font-semibold hover:underline">Terms & Conditions</Link> and <Link to="/privacy-policy" onClick={(e) => e.stopPropagation()} className="text-blue-600 font-semibold hover:underline">Privacy Policy</Link> and consent to receive communications from <strong>Deetya Soft Private Limited</strong> via SMS, Email, Calls, RCS Messages, and WhatsApp.
                          </label>
                        </div>

                        <div className="flex items-center justify-between pt-2">
                            <motion.button 
                                disabled={isSubmitting || userInputCaptcha.length < 6 || !consentGiven} 
                                whileHover={{ scale: (isSubmitting || userInputCaptcha.length < 6 || !consentGiven) ? 1 : 1.02 }} 
                                whileTap={{ scale: (isSubmitting || userInputCaptcha.length < 6 || !consentGiven) ? 1 : 0.98 }} 
                                type="submit" 
                                className="w-full py-3.5 bg-gradient-to-r from-[#0C4550] to-[#F46653] text-white font-bold rounded-xl flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {isSubmitting ? (
                                    <>Processing... <Loader2 className="w-5 h-5 animate-spin" /></>
                                ) : (
                                    <>Send Message <Send className="w-5 h-5" /></>
                                )}
                            </motion.button>
                        </div>
                      </form>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default Ivr;